import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';
import PosCartActions from '../../../actions/PosCartActions';
import GuestActions from '../../../actions/GuestActions';

import UserStore from '../../../stores/UserStore';
import PosCartStore from '../../../stores/PosCartStore';

import { endPoints as EndPoints } from '../../../constants/PosConstants';
import AjaxPromises from '../../../utils/AjaxPromises';

class Loyalty extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
            apply   : false,
            loyalty : false,
            loading: false
        };

        this.onChange = this.onChange.bind(this);
        this.applyLoyaltyPoints = this.applyLoyaltyPoints.bind(this);
    }

    onChange(e) {
        let apply = e.target.value;

        apply = apply.length === 0 ? '' : parseFloat(apply);

        let cartState = PosCartStore.getState();
        let cartSummary = PosCartStore.getCartSummary();

        let total = parseFloat(this.props.guest.LoyaltyPoints + cartState.loyaltyApplied);

        if (total < apply) {
            apply = total;
        }

        if (UserStore.getState().selectedLocation.LoyaltyAsDiscount) {
            if (apply > cartState.subTotal - (cartState.totalDiscountAndLoyalty - cartState.loyaltyApplied)) {
                apply = cartState.subTotal - (cartState.totalDiscountAndLoyalty - cartState.loyaltyApplied);
                apply = apply.toFixed(2);
            }
        } else if (apply > cartSummary.roundedDown.flt + cartState.loyaltyApplied) {
            apply = cartSummary.roundedDown.flt + cartState.loyaltyApplied;
        }

        if (apply < 0) {
            apply = 0;
        }

        this.setState({ apply : apply });
    }

    applyLoyaltyPoints() {
        let { apply } = this.state;

        if (isNaN(apply) || (!apply && apply !== 0)) {
            return;
        }

        this.setState({ loading: true });

        if (apply.length === 0) {
            apply = 0;
        }

        let formData = UserStore.getApiData();

        formData.TransactionId = this.props.guest.ShipmentId;
        formData.LoyaltyAmt = apply;
        formData.LoyaltyAsDiscount = UserStore.getState().selectedLocation.LoyaltyAsDiscount;

        AjaxPromises.POST(EndPoints.APPLY_LOYALTY_POINTS,
            formData).then(res => {
                if (res.Result === 'false') {
                    this.setState({ loading: false });
                    NotificationActions.addNotification({
                        type : 'error',
                        body : res.Message
                    });
                } else {
                    NotificationActions.addNotification({
                        type : 'success',
                        body : 'Loyalty Points Updated'
                    });
                    this.setState({ loading: false });
                    GuestActions.loadFullGuest(this.props.guest.Guest_id);
                    PosCartActions.loadUserCart(this.props.guest.Guest_id, this.props.guest.ShipmentId);
                    PopupActions.close();
                }
            }
        );
    }

    render() {
        let guest                = this.props.guest;
        let appliedLoyaltyPoints = PosCartStore.getState().loyaltyApplied;

        let display = this.state.apply !== false ? this.state.apply : appliedLoyaltyPoints;

        let total = guest.LoyaltyPoints + appliedLoyaltyPoints;

        return (
            <div className='popup__content loyalty'>
                <div className='popup-header'>
                    APPLY LOYALTY POINTS

                    <div
                        className='popup-close'
                        onClick={() => { PopupActions.close(); }}>

                        <i className="fa fa-times" aria-hidden="true" />
                    </div>
                </div>

                <div className='loyalty__available'>
                    Available: <span>{guest.LoyaltyPoints} pts</span>
                </div>

                <div className='loyalty__content'>
                    <div className='loyalty__label'>Applied</div>

                    <input
                        type='number'
                        value={display}
                        onChange={this.onChange} />
                </div>

                { !guest.IsPaid &&
                    this.state.loading ?
                    <div className='loyalty__apply btn-green'>
                        <i className='fa fa-spinner fa-pulse' /> 
                    </div>
                    :
                    <div
                        className='loyalty__apply btn-green'
                        onClick={this.applyLoyaltyPoints}>

                        APPLY
                    </div>
                }

            </div>
        );
    }
}

export default Loyalty;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/loyalty/Loyalty.react.jsx